import {  FETCH_ACTIVITIES, GET_CATEGORIES } from "../../actions/type";

  // activity intial state
  const initialActivity = {
    activities: null,
    isLoading: true,

  };
  
  export const reducer = (state = initialActivity, action) => {
    switch (action.type) {
      case FETCH_ACTIVITIES: {
        const activities = action.payload;
        return {
          ...state,
          activities: activities,
          isLoading: false,

        };
      }
      
      default:
        return state;
    }
  };